import { Subject } from 'rxjs';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

@Component({
  selector: 'sn-channel-name-dialog',
  templateUrl: './channel-name-form.component.html',
})
export class ChatChannelNameDialogComponent implements OnDestroy, OnInit {
  public form: UntypedFormGroup = new UntypedFormGroup({});
  public formModel = {
    displayName: '',
  };
  public formFields: SnFormFieldConfig[] = [];

  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly name: string,
    private readonly _dialogRef: MatDialogRef<ChatChannelNameDialogComponent>,
  ) {
    this.formModel.displayName = name;
  }

  public ngOnInit(): void {
    this.setFormFields();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public submitForm(): void {
    this._dialogRef.close(this.form.value);
  }

  public close(): void {
    this._dialogRef.close();
  }

  private setFormFields(): void {
    this.formFields = [
      {
        key: 'displayName',
        type: 'input',
        templateOptions: {
          label: t('map.telestration.channelName'),
          required: true,
        },
      },
    ];
  }
}
